export const STANDARD_WIDTH = 1200;
export const MIN_WIDTH = 480;
export const MAX_WIDTH = 2 * STANDARD_WIDTH;
// Trasa bez szerokości ("oryginał") daje natywny rozmiar tylko do tej
// szerokości - szersze źródła SharpImageProcessor pomniejsza do niej.
export const ORIGINAL_ROUTE_MAX_WIDTH = STANDARD_WIDTH;
// Rozmiar dla malych ikon (logo w menu, miniatury schema.org ImageObject) -
// MIN_WIDTH (480) to dolny prog dla zdjec treci, za duzy dla obrazka
// wyswietlanego na 44-77px.
export const ICON_WIDTH = 160;
export const DEFAULT_WIDTHS = [
    undefined,
    ICON_WIDTH,
    MIN_WIDTH,
    600,
    900,
    2 * MIN_WIDTH,
    STANDARD_WIDTH,
    // Szeroki obraz (~670-700 px CSS) przy DPR 2 potrzebuje ~1340-1400 px -
    // bez tego szczebla przeglądarka brała 1800 (~+50% bajtów).
    1440,
    2 * 900,
    MAX_WIDTH,
];
